import { useConfig } from '../../../providers/envConfig'
import useFetch from '../../helpers/useFetch'

export type AuthXboxResponse = {
  jwt: string
  gamertag: {
    modern: string
    modern_suffix: string
  }
}

// usePostXbox is a custom hook for sending a request to /auth/xbox endpoint and
// request the authentication from a given authorization code
export const usePostXbox = (authCode: string | null) => {
  const envConfig = useConfig()

  const url = `${envConfig.vpcUrl}/auth/xbox`
  const fields: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-bnet-key': envConfig.bnetKey,
    },
    credentials: 'include',
    body: JSON.stringify({
      auth_code: authCode,
      redirect_uri: envConfig.xbox.callbackUri,
    }),
  }

  const { data, loading, error, callFetch } = useFetch<AuthXboxResponse>(url, fields)

  return { data, loading, error, callFetch }
}

export default usePostXbox
